{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Przekaż do operatora",
    "MESSAGE": "Przekaż mnie do operatora"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Pobierz",
      "UPLOADING": "Przesyłanie..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Wyślij"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Wyślij wiadomość ponownie",
      "ERROR_MESSAGE": "Nie udało się wysłać! Spróbuj ponownie"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Oceń jakość tej odpowiedzi"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Poczekaj, aż dołączy agent"
  },
  "ROBOT_CHECK": {
    "TITLE": "Szybka weryfikacja bezpieczeństwa",
    "DESCRIPTION": "Proszę przejść poniższą weryfikację.",
    "VERIFYING": "Weryfikacja…",
    "ERROR": "To nie zadziałało. Spróbuj ponownie.",
    "RETRY": "Spróbuj ponownie"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Jesteśmy dostępni",
    "OFFLINE": "W tej chwili jesteśmy niedostępni",
    "ONLINE_WITH_BOT": "Zespół i nasz asystent AI są online",
    "OFFLINE_WITH_BOT": "Nasz asystent AI jest tutaj, aby pomóc",
    "BOT_ONLY_REPLY": "Odpowiada natychmiast"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Zwykle odpowiadamy w ciągu paru minut",
    "IN_A_FEW_HOURS": "Zwykle odpowiadamy w ciągu paru godzin",
    "IN_A_DAY": "Zwykle odpowiadamy w przeciągu jednego dnia",
    "BACK_IN": "Będziemy dostępni ponownie"
  },
  "DAY_NAMES": {
    "SUNDAY": "Niedziela",
    "MONDAY": "Poniedziałek",
    "TUESDAY": "Wtorek",
    "WEDNESDAY": "Środa",
    "THURSDAY": "Czwartek",
    "FRIDAY": "Piątek",
    "SATURDAY": "Sobota"
  },
  "START_CONVERSATION": "Rozpocznij rozmowę",
  "END_CONVERSATION": "Zakończ rozmowę",
  "CONTINUE_CONVERSATION": "Kontynuuj rozmowę",
  "YOU": "Ty",
  "START_NEW_CONVERSATION": "Rozpocznij nową rozmowę",
  "RESOLVE_LATER": "Rozwiążemy ten temat e-mailem/telefonicznie. Teraz chcę zapytać o coś innego.",
  "VIEW_UNREAD_MESSAGES": "Masz nieprzeczytane wiadomości",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Pokaż nowe wiadomości",
    "CLOSE_MESSAGES_BUTTON": "Zamknij",
    "COMPANY_FROM": "od",
    "BOT": "Bot"
  },
  "BUBBLE": {
    "LABEL": "Porozmawiaj z nami"
  },
  "POWERED_BY": "Napędzany przez {brandName}",
  "EMAIL_PLACEHOLDER": "Wprowadź swój adres e-mail",
  "CHAT_PLACEHOLDER": "Wpisz treść wiadomości",
  "TODAY": "Dzisiaj",
  "YESTERDAY": "Wczoraj",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Pełna nazwa (imię i nazwisko)",
        "PLACEHOLDER": "Podaj swoje imię i nazwisko",
        "REQUIRED_ERROR": "Pełne imię i nazwisko jest wymagane"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "Adres e-mail",
        "PLACEHOLDER": "Wprowadź swój adres e-mail",
        "REQUIRED_ERROR": "Adres email jest wymagany",
        "VALID_ERROR": "Wprowadź poprawny adres e-mail"
      },
      "PHONE_NUMBER": {
        "LABEL": "Numer telefonu",
        "PLACEHOLDER": "Wprowadź numer telefonu",
        "REQUIRED_ERROR": "Numer telefonu jest wymagany",
        "DIAL_CODE_VALID_ERROR": "Proszę wybrać kod kraju",
        "VALID_ERROR": "Wprowadź poprawny numer telefonu",
        "DROPDOWN_EMPTY": "Brak wyników",
        "DROPDOWN_SEARCH": "Wyszukaj kraj"
      },
      "MESSAGE": {
        "LABEL": "Wiadomość",
        "PLACEHOLDER": "Wprowadź swoją wiadomość",
        "ERROR": "Wiadomość jest za krótka"
      }
    },
    "CAMPAIGN_HEADER": "Proszę podać swoje imię i nazwisko oraz adres e-mail przed rozpoczęciem rozmowy",
    "IS_REQUIRED": "jest wymagane",
    "REQUIRED": "Wymagane",
    "REGEX_ERROR": "Wprowadź prawidłową wartość"
  },
  "FILE_SIZE_LIMIT": "Plik przekracza limit {MAXIMUM_FILE_UPLOAD_SIZE} dla załącznika",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Nieprawidłowe pole"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Wyszukaj emoji",
    "NOT_FOUND": "Nie znaleziono emoji pasującego do wyszukiwania",
    "ARIA_LABEL": "Wybór emoji"
  },
  "CSAT": {
    "TITLE": "Oceń udzielone Ci wsparcie",
    "SUBMITTED_TITLE": "Dziękujemy za przesłanie oceny",
    "PLACEHOLDER": "Dodaj swój komentarz..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Poproś o skrypt rozmowy",
    "SEND_EMAIL_SUCCESS": "Transkrypcja czatu została wysłana pomyślnie",
    "SEND_EMAIL_ERROR": "Wystąpił błąd, spróbuj ponownie"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Popularne artykuły",
    "VIEW_ALL_ARTICLES": "Zobacz wszystkie artykuły",
    "IFRAME_LOAD_ERROR": "Wystąpił błąd podczas ładowania artykułu. Odśwież stronę i spróbuj ponownie."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Otwórz",
      "BUY": "Kup"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Wiadomość z obrazkiem"
    },
    "audio": {
      "CONTENT": "Wiadomość dźwiękowa"
    },
    "video": {
      "CONTENT": "Wiadomość wideo"
    },
    "file": {
      "CONTENT": "Załącznik pliku"
    },
    "location": {
      "CONTENT": "Lokalizacja"
    },
    "fallback": {
      "CONTENT": "udostępnił adres URL"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Odpowiedź na:"
  }
}
